<template>
    <div>
        <page-card :header="$t('pages.software_news.title', {month: months[month].text, year: year})">
            <b-container fluid>
                <b-row class="align-items-end">
                    <b-col>
                        <b-form-group :label="$t('pages.software_news.select_month')" label-for="month">
                            <b-form-select v-model="month"
                                           :options="months"
                                           @input="updateNews()"
                                           id="month"></b-form-select>
                        </b-form-group>
                    </b-col>

                    <b-col>
                        <b-form-group :label="$t('pages.software_news.select_year')" label-for="year">
                            <b-form-select v-model="year"
                                           :options="years"
                                           @input="updateNews()"
                                           id="year">
                            </b-form-select>
                        </b-form-group>
                    </b-col>

                    <b-col>
                        <b-form-group :label="$t('pages.software_news.sorting')" label-for="sortButtons">
                            <b-button-group id="sortButtons">
                                <b-button @click="sortAscending = true" :class="{'active': sortAscending}">
                                    <b-icon icon="arrow-up" aria-hidden="true"></b-icon>
                                    {{ $t('pages.software_news.sort_ascending') }}
                                </b-button>
                                <b-button @click="sortAscending = false" :class="{'active': !sortAscending}">
                                    <b-icon icon="arrow-down" aria-hidden="true"></b-icon>
                                    {{ $t('pages.software_news.sort_descending') }}
                                </b-button>
                            </b-button-group>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-container>

            <callout v-if="initialRequestDone && !newsItems.length">
                {{ $t('pages.software_news.no_results') }}
            </callout>

            <!-- single new item -->
            <b-list-group>
                <b-list-group-item v-for="item of newsItems" :key="item.id">
                    <div class="d-flex w-100 justify-content-between">
                        <h5 class="mb-1">
                            <a :href="`/i/software/details/${item['hash']}`">{{ item['Programm-Name'] }}</a>
                        </h5>
                        <small>
                            ({{ $t("pages.software_news.published_at") }}
                            {{ $d(new Date(item['created_at']), 'medium') }} {{ $t("common.oclock") }})
                        </small>
                    </div>

                    <p class="mb-1" v-html="item['content']"></p>
                </b-list-group-item>
            </b-list-group>
        </page-card>
    </div>
</template>
<script>
import GenericNotification from "../layout/GenericNotification";
import LoadingInjector from "../../mixins/LoadingInjector";
import PageCard from "../layout/PageCard";
import Callout from "../layout/Callout";

export default {
    name: "software-news",
    mixins: [
        LoadingInjector
    ],
    components: {
        GenericNotification,
        PageCard,
        Callout,
    },
    props: {
        initialMonth: null,
        initialYear: null
    },
    data: function () {
        return {
            month: this.initialMonth ? parseInt(this.initialMonth) : new Date().getMonth(),
            year: this.initialYear ? parseInt(this.initialYear) : new Date().getFullYear(),
            // generates an array containing months as the options for dropdown
            months: [...Array(12).keys()].map((m, i) => {
                return {"value": m, "text": this.$i18n.t('common.months.' + m)}
            }),
            // generates an array containing the last 12 years as options for dropdown
            years: [...Array(12).keys()].map((el, i) => {
                    let y = new Date().getFullYear() - el;
                    return {"value": y, "text": y}
                }
            ),
            newsItems: [],
            // don't show callout if we haven't even fetched items for the first time
            initialRequestDone: false,
            sortAscending: false,
            sortDescending: true
        }
    },
    created() {
        this.updateNews();
    },
    watch: {
        sortAscending: function() {
            this.sortNews();
        }
    },
    methods: {
        sortNews: function (ascending = this.sortAscending) {
            this.newsItems.sort((a, b) => {
                return ascending
                    ? parseInt(a.id) - parseInt(b.id)
                    : parseInt(b.id) - parseInt(a.id)
            })
        },
        updateNews: function (month = this.month, year = this.year) {
            // change url fragment so the URL to this news page can be reused
            let newPath = `/i/software/news?month=${month}&year=${year}`
            if(this.$router.currentRoute.fullPath !== newPath) {
                this.$router.replace(newPath);
            }
            let url = `/i/software/news/items?month=${month + 1}&year=${year}`
            this.$http.get(url)
                .then(response => {
                    this.newsItems = response.data;
                    this.initialRequestDone = true;
                    this.sortNews();
                })
        }
    }
};
</script>
